import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

/**
 * @param isPrimary - Theme
 * @param brandingColor - Branding Profile Color
 */
/**
 * Properties for the CCF Loader component
 */
interface CcfLoaderStylesOptions {
  /**
   * Is Primary Boolean Value for Theme Color
   */
  isPrimary?: boolean;
  /**
   * Branding Color Value as given in Branding Profile Object
   */
  brandingColor?: string;
}

/**
 * @param theme - Theme palette
 * @param ccfLoaderOptions - isPrimary and brandingColor options
 * @returns ccfLoaderStyles
 * @example - ccfLoaderStyles
 */
const ccfLoaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    loaderContainer: {
      display: 'inline-flex',
    },
    loaderBox: {
      margin: 0,
      display: 'flex',
      paddingLeft: 0,
    },
    loaderBar: {
      listStyle: 'none',
      width: '4px',
      height: '9px',
      background: (options: CcfLoaderStylesOptions) =>
        options.brandingColor
          ? options.brandingColor
          : options.isPrimary
          ? theme?.palette?.primary?.main
          : theme?.palette?.background?.paper,
      margin: '10px 4px',
      animation: '$animate .7s infinite alternate',
    },
    firstLoaderBar: {
      animationDelay: '0.1s',
    },
    secondLoaderBar: {
      animationDelay: '0.2s',
    },
    thirdLoaderBar: {
      animationDelay: '0.3s',
    },
    loaderColor: {
      color: (options) =>
        options.isPrimary
          ? theme?.palette?.primary?.main
          : theme?.palette?.background?.paper,
    },
    '@keyframes animate': {
      '0%': {
        transform: 'scaleY(1)',
      },
      '25%': {
        transform: 'scaleY(1)',
      },
      '50%': {
        transform: 'scaleY(1)',
      },
      '75%': {
        transform: 'scaleY(1)',
      },
      '100%': {
        transform: 'scaleY(3)',
      },
    },
  })
);
export default ccfLoaderStyles;
